/**
 * Enum representing the span of modifications.
 *
 * @enum EventSpan
 * @platform iOS
 */
export var EventSpan;
(function (EventSpan) {
    /**
     * The modifications should only be applied to this event.
     */
    EventSpan[EventSpan["THIS_EVENT"] = 0] = "THIS_EVENT";
    /**
     * The modifications to this event should also be applied to the future instances of this event.
     */
    EventSpan[EventSpan["THIS_AND_FUTURE_EVENTS"] = 1] = "THIS_AND_FUTURE_EVENTS";
})(EventSpan || (EventSpan = {}));
//# sourceMappingURL=event-span.js.map